'use client';

import React from 'react';
import Link from 'next/link';

export default function SiteServices() {
  const services = [
    {
      title: 'Sob Medida',
      icon: 'cut',
      desc: 'Noivas, madrinhas, debutantes e formandas. Criações exclusivas desenhadas para o seu corpo e estilo.',
      link: '#contato',
      action: 'Solicitar Orçamento'
    },
    {
      title: 'Aluguel de Luxo',
      icon: 'checkroom',
      desc: 'Um acervo impecável de vestidos de festa, gala e casual chic, com ajustes personalizados inclusos.',
      link: '#aluguel',
      action: 'Ver Acervo',
      featured: true
    },
    {
      title: 'Consultoria Especializada',
      icon: 'diamond',
      desc: 'Definição de paleta, tecidos e modelagens que mais valorizam você para o seu grande dia.',
      link: '#contato',
      action: 'Agendar Sessão'
    }
  ];

  return (
    <section id="servicos" className="py-xl bg-surface">
      <div className="max-w-7xl mx-auto px-lg">
        <div className="text-center mb-xl">
          <span className="text-label-caps text-primary tracking-[0.2em] font-bold">NOSSOS SERVIÇOS</span>
          <h2 className="text-h2 text-on-surface mt-2">Experiências Personalizadas</h2>
          <p className="text-body-lg text-secondary max-w-2xl mx-auto mt-4 leading-relaxed">
            Unimos o tradicional ao moderno para criar o que há de mais sofisticado em vestuário.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-gutter">
          {services.map((service, idx) => (
            <div 
              key={idx} 
              className={`bg-white p-xl rounded-3xl ambient-shadow flex flex-col items-center text-center transition-all duration-300 hover:scale-[1.02] border ${
                service.featured ? 'border-primary/30 ring-4 ring-primary/5' : 'border-outline-variant/10'
              }`}
            >
              <div className="w-20 h-20 rounded-full bg-primary/10 flex items-center justify-center text-primary mb-lg">
                <span className="material-symbols-outlined text-[40px]">{service.icon}</span>
              </div>
              <h3 className="text-h3 text-on-surface mb-md">{service.title}</h3>
              <p className="text-body-md text-secondary mb-lg leading-relaxed">
                {service.desc}
              </p>
              <Link 
                href={service.link}
                className={`mt-auto font-button text-button transition-all border-b-2 ${
                  service.featured ? 'text-primary border-primary hover:pb-1' : 'text-secondary border-transparent hover:border-secondary'
                }`}
              >
                {service.action}
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
